export default "__VITE_ASSET__DWEhTdlq__"